/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { selectGridSelection } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.selector';
import { selectFiterAttributes, selectGridState } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { XGrid } from '@AMIEWEB/Common/XGrid/XGrid';
import { ArchivePlacementDialog } from '@AMIEWEB/GlobalSearch/Placement/ArchivePlacementDialog';
import { formatMultiSortColumns, formatMultiSortXGridColumns, getFilterRequest } from '@AMIEWEB/GlobalSearch/helper';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { GridDensity } from '@mui/x-data-grid';
import {
  GridCallbackDetails,
  GridColumnVisibilityModel,
  GridColumns,
  GridFilterModel,
  GridPinnedColumns,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import { useDecision } from '@optimizely/react-sdk';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { SortColumn, gridStateActions } from 'app/components/Common/Grid/GridStateManagement/GridState.redux';
import { placementViewInfo } from 'app/components/GlobalSearch/Placement/SearchUtils';
import { notOrderColumns } from 'app/components/Placement/AssociatedPlacements/store/utils';
import { ff_placement_region_fields } from 'app/constants/FeatureFlags/Placement/Keys';
import { ff_candidate_communication_grid } from 'app/constants/FeatureFlags/Tasks/Notifications/Keys';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { GridColumns as GlobalGridColumns, SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import _, { isEmpty } from 'lodash';
import { userDevicePreferenceActions } from 'oidc/UserDevicePreference/userPreference.redux';
import { selectUserPreference } from 'oidc/UserDevicePreference/userPreference.selectors';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrderDetailsUpdated } from 'store/redux-store/create-order-ocbr/selector';
import { createOrderOcbrActions } from 'store/redux-store/create-order-ocbr/slice';
import { selectArchivePlacements, selectSearchResults } from 'store/redux-store/global-search/selectors';
import { globalSearchActions } from 'store/redux-store/global-search/slice';
import { makeStyles } from 'tss-react/mui';
import { RootState } from 'types';
import { usePinnedColumnsPreference } from 'app/components/Common/XGrid/Hooks/usePinnedColumnsPreference';

const useStyles = makeStyles()({
  container: {
    // To be refactored w.r.t to grid height
    paddingBottom: 40,
  },
});
export const orderCandidateMatchVisibiltyModel = {
  orderId: true,
  placementId: true,
  PlacementTag: true,
  candidateId: false,
  firstName: false,
  lastName: false,
  goesBy: false,
  otherName: false,
  phones: false,
  emails: false,
  status: true,
  statusAge: true,
  brand: true,
  division: true,
  candidate: true,
  facility: true,
  unit: true,
  skillsets: true,
  placementCreated: true,
  screen: true,
  fileSentDate: true,
  availableStartDate: true,
  startDate: true,
  endDate: true,
  extensionStatus: true,
  extensionStatusLastUpdateDate: true,
  accountManager: true,
  recruiter: true,
  credentialingAnalyst: true,
  placementCuedTo: true,
  cueNote: true,
  contractAffiliate: true,
  contractAffiliateId: true,
  clientContractSpecialist: true,
  clinicalManager: true,
  facilityId: true,
  staffingVendor: true,
  region: false,
  zip: false,
};

export const OrderPlacementGrid = ({
  columns,
  setColumns,
  rootFilter,
  defaultColumns,
  ...props
}: {
  columns: GridColumns;
  setColumns: any;
  rootFilter: any;
  defaultColumns: any;
  [key: string]: any;
}) => {
  let rootFilterString = JSON.stringify(rootFilter);
  const { t } = useTranslation();
  const gridTag = 'OrderPlacementMatch';
  const { classes } = useStyles();
  const { items: rows, count } = useSelector(selectSearchResults);
  const gridState = useSelector(selectGridState);
  const orderDetailsUpdate = useSelector(selectOrderDetailsUpdated);
  const dispatch = useDispatch();
  const { promiseInProgress } = usePromiseTracker({ area: 'global-search-call' });
  const defaultColumn = { column: 'placementCreated', direction: 'desc' };
  const defaultMultiSort: SortColumn[] = [{ column: 'placementCreated', direction: 'desc' }];
  const defaultSort = [{ field: 'placementCreated', sort: 'desc' }];
  const [xGridSortModel, setXgridSortModel] = React.useState<any>(defaultSort);
  const apiRef = useGridApiRef();
  const [defaultColumnVisibilityModel] = React.useState<any>(_.cloneDeep(orderCandidateMatchVisibiltyModel));
  const [currentColumnVisibilityModel, setCurrentColumnVisibilityModel] = React.useState<any>(
    _.cloneDeep(orderCandidateMatchVisibiltyModel),
  );
  const userPreference = useSelector(selectUserPreference);
  const gridPreferences = useSelector((state: RootState) => {
    return state.userPreferenceData.userGridPreferences.find(item => item.id === gridTag);
  });
  const [pinnedColumns, setPinnedColumns] = React.useState<GridPinnedColumns>({
    left: ['orderId'],
  });
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({ items: [] });
  const [density, setDensity] = React.useState<GridDensity>('compact');
  const [showResetButton, setShowResetButton] = React.useState<boolean>(false);
  const [disableArchivePlacements, setDisableArchivePlacements] = React.useState<boolean>(true);
  const { selectedData } = useSelector(selectGridSelection);
  const { success: archivePlacementStatus } = useSelector(selectArchivePlacements);
  const filters = useSelector(selectFiterAttributes);
  const [candidateCommunicationConsentFlag] = useDecision(ff_candidate_communication_grid);
  const [regionFlag] = useDecision(ff_placement_region_fields);

  const handleFetchData = (
    offset: number,
    page: number,
    sortedColumn?: { column: string; direction: any } | undefined | null,
    multiSortedColumns?: SortColumn[],
  ) => {
    dispatch(
      globalSearchActions.getSearchResults({
        searchType: SearchType.placement,
        filter: !isEmpty(rootFilter) ? getFilterRequest(rootFilter?.filter, rootFilter?.selectedChipFilters) : {},
        keyword: '',
        pageNumber: page,
        pageSize: offset,
        sortedColumn: sortedColumn || gridState.sortedColumn,
        multiSortedColumns: multiSortedColumns || gridPreferences?.value?.multiSortedColumns,
        translation: t,
        navigationDataLoad: false,
      }),
    );
  };

  const saveSortModel = React.useCallback(
    sortModel => {
      const sortedColumn =
        sortModel?.length > 0
          ? {
              column: sortModel[0].field,
              direction: sortModel[0].sort,
            }
          : undefined;
      const multiSortedColumns = sortModel?.length > 0 ? formatMultiSortColumns(sortModel) : undefined;
      if (
        !_.isEqual(sortedColumn, gridState?.sortedColumn) ||
        !_.isEqual(multiSortedColumns, gridState?.multiSortedColumns)
      ) {
        const preferenceData = {
          id: gridTag,
          value: {
            ...(gridPreferences?.value || {}),
            sortedColumn: sortedColumn,
            multiSortedColumns: multiSortedColumns,
          },
        };
        setShowResetButton(true);
        dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
      }
    },
    [dispatch, gridPreferences?.value, gridState?.sortedColumn, gridState?.multiSortedColumns],
  );
  const onSortModelChanged = (model: GridSortModel) => {
    const pagination = apiRef?.current?.state?.pagination;
    const multiSortedColumns = model?.length > 0 ? formatMultiSortColumns(model) : undefined;
    if (pagination) {
      handleFetchData(
        pagination.pageSize,
        pagination.page + 1,
        model.length > 0
          ? {
              column: model[0].field,
              direction: model[0].sort,
            }
          : undefined,
        multiSortedColumns,
      );
    }
    if (model?.length > 0) {
      saveSortModel(model);
    }
    setXgridSortModel(model);
  };

  const onPageChange = (page: number) => {
    const pagination = apiRef?.current?.state?.pagination;
    if (pagination)
      handleFetchData(pagination.pageSize, page + 1, gridState.sortedColumn, gridState?.multiSortedColumns);
  };

  const onPageSizeChange = (pageSize: number) => {
    if (gridState.pageSize !== pageSize)
      handleFetchData(pageSize, 1, gridState.sortedColumn, gridState?.multiSortedColumns);
  };

  const fetchData = () => {
    const pagination = apiRef?.current?.state?.pagination;
    handleFetchData(pagination.pageSize, 1, gridState.sortedColumn, gridState.multiSortedColumns);
  };

  useEffect(() => {
    if (!isEmpty(rootFilter)) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootFilterString]);

  useEffect(() => {
    if (!isEmpty(rootFilter) && orderDetailsUpdate) {
      fetchData();
      dispatch(createOrderOcbrActions.setOrderDetailsUpdatedFlag(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetailsUpdate]);
  const handleGridChanges = state => {
    if (state.density.value !== density) {
      setDensity(state.density.value);
      const preferenceData = {
        id: gridTag,
        value: {
          ...(gridPreferences?.value || {}),
          gridDensity: state.density.value,
        },
      };
      dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
    }

    const current = apiRef.current;
    const currentGridColumns = _.cloneDeep(current.getAllColumns());
    if (currentGridColumns && currentGridColumns.length > 0 && currentGridColumns[0].field === '__check__')
      currentGridColumns.shift();
    const fields = _.cloneDeep(current.state.columns.all);
    if (fields.length > 0 && fields[0] === '__check__') fields.shift();
  };
  const savePreferences = React.useCallback(
    ({
      field,
      columns: gridColumns,
      visibilityModel,
    }: {
      field?: string;
      columns: any;
      visibilityModel: GridColumnVisibilityModel;
    }) => {
      if (!columns || columns.length === 0 || !userPreference.loaded) return;
      const currentGridColumns = new GlobalGridColumns(gridColumns).columns;
      if (currentGridColumns && currentGridColumns.length > 0 && currentGridColumns[0].field === '__check__')
        currentGridColumns.shift();

      const comparableColumns = new GlobalGridColumns(
        gridPreferences?.value?.columns,
        gridPreferences?.value?.columnVisibilityModel,
      );
      const columnsEqual = comparableColumns.isEqual(currentGridColumns);
      const visibilityEqual = comparableColumns.isVisibilityModelEqual(visibilityModel);

      if (!columnsEqual || !visibilityEqual) {
        const preferenceData = {
          id: gridTag,
          value: {
            ...(gridPreferences?.value || {}),
            columns: currentGridColumns,
            columnVisibilityModel: visibilityModel,
          },
        };
        setShowResetButton(true);
        dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
      }
    },
    [columns, userPreference.loaded, defaultColumns?.length, gridPreferences?.value, dispatch],
  );

  const handlePinnedColumnsChange = usePinnedColumnsPreference({
    gridTag,
    gridPreferences,
    setPinnedColumns,
    setShowResetButton,
  });

  const saveFilterPreference = React.useCallback(
    (updatedFilter: GridFilterModel, details: GridCallbackDetails) => {
      setFilterModel(updatedFilter);
      const preferenceData = {
        id: gridTag,
        value: {
          ...(gridPreferences?.value || {}),
          updatedFilter: updatedFilter,
        },
      };
      dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
    },
    [filterModel, userPreference.loaded, gridPreferences?.value, dispatch],
  );

  const handleRefreshGrid = async () => {
    fetchData();
  };
  
  const handleResetColumns = async () => {
    setPinnedColumns({ left: ['orderId'] });
    setDensity('standard');
    setFilterModel({ items: [] });
    setShowResetButton(false);
    setColumns(
      placementViewInfo(t, [], candidateCommunicationConsentFlag.enabled).filter(
        column =>
          !(regionFlag.enabled ? notOrderColumns : [...notOrderColumns, 'region']).some(
            notValue => notValue === column.field,
          ),
      ),
    );
    setCurrentColumnVisibilityModel(orderCandidateMatchVisibiltyModel);
    dispatch(gridStateActions.setSortedColumn({ column: 'placementCreated', direction: 'desc' }));
    dispatch(gridStateActions.setMultiSortedColumn([{ column: 'placementCreated', direction: 'desc' }]));
    setXgridSortModel(defaultSort);
    const preferenceData = {
      id: gridTag,
      value: {
        ...(gridPreferences?.value || {}),
        columns: defaultColumns,
        columnVisibilityModel: defaultColumnVisibilityModel,
        sortedColumn: { column: 'placementCreated', direction: 'desc' },
        multiSortedColumns: [{ column: 'placementCreated', direction: 'desc' }],
        pinnedColumns: { left: ['orderId'] },
        gridDensity: 'standard',
        updatedFilter: { items: [] },
      },
    };
    dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
    if (!(gridState?.sortedColumn?.column === 'placementCreated' && gridState?.sortedColumn?.direction === 'desc')) {
      handleFetchData(gridState.pageSize, gridState.pageNumber, defaultColumn, defaultMultiSort);
    }
  };
  React.useEffect(() => {
    dispatch(gridStateActions.setGrid('OrderPlacementMatch'));
    return () => {
      dispatch(
        gridStateActions.setSortedColumn({
          column: 'placementCreated',
          direction: 'desc',
        }),
      );
      dispatch(gridStateActions.setMultiSortedColumn(gridState?.multiSortedColumns));
    };
  }, []);
  React.useEffect(() => {
    // Reset grid selection regardless of archive filter
    if (
      archivePlacementStatus &&
      (filters?.filters as any[])?.find(
        item => item[0] === 'archiveStatus' && (item[1]?.name === 'No' || item[1]?.name === 'Yes'),
      )
    ) {
      // Get new data when archive filter is applied
      setTimeout(() => {
        fetchData();
      }, 1500);

      apiRef?.current?.setSelectionModel([]);
      dispatch(globalSearchActions.setBulkArchivePlacements({ dialogOpen: false, success: null, loading: false }));
    }
  }, [archivePlacementStatus, dispatch, handleFetchData, xGridSortModel]);

  const getVisibilityPreferences = (cols: any) => {
    const columnPreferences = gridPreferences?.value;
    if (columnPreferences && columnPreferences?.columnVisibilityModel) {
      return _.merge(cols, columnPreferences?.columnVisibilityModel);
    }
    return cols;
  };

  const getColumnPreferences = (cols: any[]) => {
    try {
      const columnPreferences = gridPreferences?.value;
      if (columnPreferences && columnPreferences.columns) {
        const newColumns = cols.map(column => {
          const foundIndex = columnPreferences.columns.findIndex(item => item?.field === column?.field);
          if (foundIndex !== -1) {
            return {
              ...column,
              ...columnPreferences.columns[foundIndex],
            };
          } else {
            return column;
          }
        });
        return newColumns.sort((a, b) => {
          return (
            columnPreferences.columns.findIndex(i => i.field === a.field) -
            columnPreferences.columns.findIndex(i => i.field === b.field)
          );
        });
      }
      return cols;
    } catch (err) {
      return cols;
    }
  };

  const determineGridColumns = () => {
    const currentGridColumns = getColumnPreferences(defaultColumns);
    setColumns(currentGridColumns);
  };
  const determineVisibilityModel = () => {
    const currentVisibilityModel = getVisibilityPreferences(defaultColumnVisibilityModel);
    setCurrentColumnVisibilityModel(currentVisibilityModel);
    setColumns(
      placementViewInfo(t, [], candidateCommunicationConsentFlag.enabled).filter(
        column =>
          !(regionFlag.enabled ? notOrderColumns : [...notOrderColumns, 'region']).some(
            notValue => notValue === column.field,
          ),
      ),
    );
  };

  const getSortModelPreferences = (sortModel: any[]) => {
    const columnPreferences = gridPreferences?.value;
    if (
      columnPreferences &&
      columnPreferences?.multiSortedColumns &&
      Array.isArray(columnPreferences?.multiSortedColumns)
    ) {
      return formatMultiSortXGridColumns(columnPreferences?.multiSortedColumns);
    }
    return sortModel;
  };
  const determineSortModel = () => {
    const currentGridSortModel = getSortModelPreferences(xGridSortModel);
    setXgridSortModel(currentGridSortModel);
    if (
      !gridState?.sortedColumn ||
      (gridState?.sortedColumn &&
        (gridState.sortedColumn.column !== currentGridSortModel[0].field ||
          gridState.sortedColumn.direction !== currentGridSortModel[0].sort))
    )
      dispatch(
        gridStateActions.setSortedColumn({
          column: currentGridSortModel[0].field,
          direction: currentGridSortModel[0].sort,
        }),
      );
    if (gridState?.multiSortedColumns?.length > 0) {
      dispatch(gridStateActions.setMultiSortedColumn(gridState?.multiSortedColumns));
      setShowResetButton(true);
    }
  };
  const determinePinnedColumns = () => {
    if (gridPreferences?.value?.pinnedColumns) {
      setPinnedColumns(gridPreferences?.value?.pinnedColumns);
    }
  };
  const determineFilters = () => {
    if (gridPreferences?.value?.updatedFilter) {
      setFilterModel(gridPreferences?.value?.updatedFilter);
    }
  };
  const determineDensity = () => {
    if (gridPreferences?.value?.gridDensity) {
      setDensity(gridPreferences?.value?.gridDensity);
    }
  };
  useEffect(() => {
    if (userPreference?.loaded) {
      dispatch(gridStateActions.setGrid(gridTag));
      determineGridColumns();
      determineVisibilityModel();
      determineSortModel();
      determinePinnedColumns();
      determineFilters();
      determineDensity();
      if (gridPreferences?.value?.multiSortedColumns) {
        setShowResetButton(gridPreferences.value.multiSortedColumns.length > 1);
      }
    }
  }, [userPreference?.loaded]);

  const leftActions = React.useMemo(() => {
    return [
      {
        title: 'global.xgrid.toolbar.archive',
        Icon: ArchiveOutlinedIcon,
        disabled: disableArchivePlacements,
        onClick: () => {
          dispatch(globalSearchActions.setBulkArchivePlacements({ dialogOpen: true }));
        },
        enableReadOnly: true,
      },
    ];
  }, [dispatch, disableArchivePlacements, selectedData.length]);

  /** Enable or disable Archive Placements action button */
  React.useEffect(() => {
    if (selectedData?.length > 0) {
      dispatch(
        globalSearchActions.getArchivablePlacements({
          result: rowsList => {
            setDisableArchivePlacements(rowsList?.length === 0);
          },
        }),
      );
    } else {
      setDisableArchivePlacements(true);
    }
  }, [dispatch, selectedData]);

  const GridComponent = React.useMemo(() => {
    return (
      <XGrid
        apiRef={apiRef}
        columns={columns}
        rowsPerPageOptions={[250, 300, 400, 500]}
        defaultRowsPerPage={250}
        defaultColumns={defaultColumns}
        defaultColumnVisibilityModel={defaultColumnVisibilityModel}
        columnVisibilityModel={currentColumnVisibilityModel}
        disableMultipleColumnsSorting={false}
        rows={rows || []}
        rowCount={count}
        autoHeight={false}
        loading={promiseInProgress}
        onSortModelChange={onSortModelChanged}
        defaultSortModel={xGridSortModel}
        sortModel={xGridSortModel}
        onStateChange={handleGridChanges}
        gridTag={'OrderPlacementMatch'}
        paginationMode="server"
        sortingMode="server"
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        onColumnResizeStop={_columns => {
          savePreferences({
            field: undefined,
            columns: _columns,
            visibilityModel: _.cloneDeep(currentColumnVisibilityModel ?? defaultColumnVisibilityModel),
          });
        }}
        onColumnOrderChange={(params, event, details, _columns) => {
          savePreferences({
            field: params.field,
            columns: _columns,
            visibilityModel: _.cloneDeep(currentColumnVisibilityModel ?? defaultColumnVisibilityModel),
          });
        }}
        onColumnVisibilityModelChange={(model, details) => {
          dispatch(gridStateActions.setColumnVisibilityModel(model));
          setCurrentColumnVisibilityModel(_.cloneDeep(model));
          savePreferences({
            field: undefined,
            columns: _.cloneDeep(apiRef?.current?.getAllColumns()),
            visibilityModel: _.cloneDeep(model),
          });
        }}
        filterModel={filterModel}
        onFilterModelChange={saveFilterPreference}
        pinnedColumns={pinnedColumns}
        onPinnedColumnsChange={handlePinnedColumnsChange}
        density={density}
        toolbarProps={{
          refreshButton: true,
          filterButton: true,
          resetButton: showResetButton,
          leftActions,
          refreshGrid: () => {
            handleRefreshGrid();
          },
          resetColumns: () => {
            handleResetColumns();
            dispatch(
              globalActions.setSnackBar({
                message: 'Columns have been reset.',
                severity: 'success',
              }),
            );
          },
        }}
        disableSelectionOnClick
        title={`Placements`}
        checkboxSelection
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    density,
    filterModel,
    pinnedColumns,
    rows,
    columns,
    xGridSortModel,
    promiseInProgress,
    leftActions,
    currentColumnVisibilityModel,
    showResetButton,
  ]);

  return (
    <LayoutGrid>
      <LayoutGridItem xs={12}>
        <Box className={classes.container}>
          {GridComponent} <ArchivePlacementDialog />
        </Box>
      </LayoutGridItem>
    </LayoutGrid>
  );
};
